import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "tw-flex tw-items-center"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "tw-line-clamp-1" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerChevronDown = _resolveComponent("TablerChevronDown")!
  const _component_TablerX = _resolveComponent("TablerX")!

  return (_ctx.selectedItemsTitles.length === 0)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "tw-group tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-px-3 tw-py-2.5 tw-pr-2.5 tw-text-xs tw-font-medium hover:tw-border-transparent hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400",
        type: "button",
        disabled: _ctx.disabled,
        "data-testid": "multiselect-trigger-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOpenClick && _ctx.handleOpenClick(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.buttonText) + " ", 1),
        _createVNode(_component_TablerChevronDown, { class: "tw-ml-1 tw-h-3 tw-w-3 tw-text-slate-500 group-hover:tw-text-deep-orange-400" })
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-l-lg tw-bg-deep-orange-50 tw-pl-3 tw-pr-1.5 tw-text-xs tw-font-medium tw-text-deep-orange hover:tw-bg-deep-orange-100 focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400",
          type: "button",
          disabled: _ctx.disabled,
          "data-testid": "multiselect-trigger-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleOpenClick && _ctx.handleOpenClick(...args)))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.buttonText), 1)
        ], 8, _hoisted_3),
        _createElementVNode("button", {
          class: "tw-h-8 tw-rounded-r-lg tw-bg-deep-orange-50 tw-px-1.5 tw-text-deep-orange hover:tw-bg-deep-orange-100 disabled:tw-cursor-not-allowed disabled:tw-border-slate-200 disabled:tw-bg-slate-50 disabled:tw-text-slate-400",
          "data-testid": "multiselect-trigger-clear-button",
          type: "button",
          disabled: _ctx.disabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClearClick && _ctx.handleClearClick(...args)))
        }, [
          _createVNode(_component_TablerX, { class: "tw-h-3.5 tw-w-3.5" })
        ], 8, _hoisted_5)
      ]))
}